import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-759647d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  autoplay: "",
  class: "video-header__video",
  height: "100%",
  loop: "",
  muted: "",
  width: "100%"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "hero__background"
}
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "hero__background-circles",
  viewBox: "0 0 1154 1154"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "#FFF",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "577",
      cy: "577",
      opacity: ".033",
      r: "577"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "577.5",
      cy: "576.5",
      opacity: ".037",
      r: "405.5"
    })
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "hero__body" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row row-gap-2" }
const _hoisted_11 = { class: "col-md-8" }
const _hoisted_12 = {
  key: 1,
  class: "d-flex hero__footer mt-3 gap-2"
}
const _hoisted_13 = {
  key: 0,
  class: "col-md-4 mt-2 m-md-0"
}
const _hoisted_14 = { class: "d-flex p-2" }
const _hoisted_15 = ["alt"]
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = {
  key: 0,
  class: "lead font-weight-bold mb-0"
}
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "d-flex flex-column align-items-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroSearchBar = _resolveComponent("HeroSearchBar")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hero", _ctx.backgroundColor])
  }, [
    (_ctx.vm.backgroundVideoUrl)
      ? (_openBlock(), _createElementBlock("video", _hoisted_1, [
          _createElementVNode("source", {
            src: _ctx.vm.backgroundVideoUrl
          }, null, 8, _hoisted_2)
        ]))
      : (_ctx.vm.backgroundImage?.url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              alt: _ctx.vm.backgroundImage?.alt,
              class: "hero__background__image",
              src: _ctx.vm.backgroundImage?.url
            }, null, 8, _hoisted_4)
          ]))
        : (_ctx.vm.heroBackgroundColor === _ctx.HeroBackgroundColorEnum.magenta)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h1", {
              class: _normalizeClass(["display-3 text-shadow", {
								'text-white':
									_ctx.hasBackground || _ctx.vm.heroBackgroundColor === _ctx.HeroBackgroundColorEnum.magenta,
							}])
            }, _toDisplayString(_ctx.vm.title), 3),
            _createElementVNode("h3", {
              class: _normalizeClass(["display-5", {
								'text-white':
									_ctx.hasBackground || _ctx.vm.heroBackgroundColor === _ctx.HeroBackgroundColorEnum.magenta,
							}])
            }, _toDisplayString(_ctx.vm.subtitle), 3),
            (!_ctx.vm.hideSearch)
              ? (_openBlock(), _createBlock(_component_HeroSearchBar, {
                  key: 0,
                  vm: _ctx.searchBarVm
                }, null, 8, ["vm"]))
              : _createCommentVNode("", true),
            (_ctx.vm.firstCtaLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.vm.firstCtaLink)
                    ? (_openBlock(), _createBlock(_component_LinkButton, {
                        key: 0,
                        class: _normalizeClass(["p-button-link p-button-primary", {
									'text-white': _ctx.vm.heroBackgroundColor === _ctx.HeroBackgroundColorEnum.magenta,
								}]),
                        label: _ctx.vm.firstCtaLink.text,
                        target: _ctx.vm.firstCtaLink.target,
                        title: _ctx.vm.firstCtaLink.title,
                        url: _ctx.vm.firstCtaLink.url
                      }, null, 8, ["class", "label", "target", "title", "url"]))
                    : _createCommentVNode("", true),
                  (_ctx.vm.secondCtaLink)
                    ? (_openBlock(), _createBlock(_component_LinkButton, {
                        key: 1,
                        class: _normalizeClass(["p-button-link p-button-primary", {
									'text-white': _ctx.vm.heroBackgroundColor === _ctx.HeroBackgroundColorEnum.magenta,
								}]),
                        label: _ctx.vm.secondCtaLink.text,
                        target: _ctx.vm.secondCtaLink.target,
                        title: _ctx.vm.secondCtaLink.title,
                        url: _ctx.vm.secondCtaLink.url
                      }, null, 8, ["class", "label", "target", "title", "url"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.vm.serviceIntro && _ctx.vm.serviceTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_Card, null, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.vm.serviceImage)
                        ? (_openBlock(), _createBlock(_component_Avatar, {
                            key: 0,
                            class: "mr-2 service-img flex-shrink-0",
                            shape: "circle"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("img", {
                                alt: _ctx.vm.serviceImage?.alt,
                                height: "80px",
                                width: "80px"
                              }, null, 8, _hoisted_15), [
                                [_directive_lazy, _ctx.vm.serviceImage?.url]
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        (_ctx.vm.serviceTitle)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_17, _toDisplayString(_ctx.vm.serviceTitle), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.vm.serviceIntro), 1)
                      ])
                    ])
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      (_ctx.vm.askAQuestionPageUrl)
                        ? (_openBlock(), _createBlock(_component_LinkButton, {
                            key: 0,
                            class: "ml-0 mb-1 p-button-link flex-1",
                            icon: "pi pi-envelope",
                            label: _ctx.$t('support.button.askAQuestion'),
                            url: _ctx.vm.askAQuestionPageUrl
                          }, null, 8, ["label", "url"]))
                        : _createCommentVNode("", true),
                      (_ctx.layoutStore.chatWidgetAvailable)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "ml-0 mb-1 p-button-link flex-1",
                            icon: "pi pi-comment",
                            label: _ctx.$t('support.button.chatWithUs'),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.initChat()))
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}